import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { DeleteDynamicPricingGroupResponseSchema } from "../response/DeleteDynamicPricingGroupResponse";

interface DeleteVariables {
    groupId: string;
}

/**
 * Custom hook untuk menghapus Dynamic Pricing Group.
 */
export const useDeleteDynamicPricingGroup = () => {
    return useMutation({
        mutationFn: async ({ groupId }: DeleteVariables) => {
            try {
                const response = await privateApi.delete(`/v4/dynamic-pricing/group/${groupId}`);
                return response.data;
            } catch (error) {
                console.error(`Failed to delete group with ID ${groupId}:`, error);
                throw error;
            }
        },
        onSuccess: (responseData) => {
            const validationResult = DeleteDynamicPricingGroupResponseSchema.safeParse(responseData);
            if (!validationResult.success) {
                throw new Error("Invalid data format received from server after deletion.");
            }
        },
    });
};